import { render, staticRenderFns } from "./serveorderlist.vue?vue&type=template&id=62819a96&scoped=true&"
import script from "./serveorderlist.vue?vue&type=script&lang=js&"
export * from "./serveorderlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62819a96",
  null
  
)

export default component.exports